<template>
    <div class="meal-category">
        <div :id="'meal-category-' + category.id">
            <div class="d-flex justify-space-between align-center">
                <h2 class="my-4">
                    {{ category.name }}
                </h2>
            </div>
            <edit-meal-category></edit-meal-category>
            <meal-list
                :category="category"
                :restaurant="restaurant"
                @items-updated="itemsUpdated"
            ></meal-list>
            <v-btn class="mt-5" @click="createMeal">
                <v-icon left>add</v-icon>
                {{ $t('labels.add_new_meal') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import EditMealCategory from '@/components/pages/meals/mealCategory/EditMealCategory'
import MealList from '@/components/pages/meals/MealList'
import mealType from '@/store/type/mealType'

export default {
    components: {
        EditMealCategory,
        MealList,
    },

    props: {
        restaurant: {
            type: String,
            default: null,
        },
        category: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    methods: {
        createMeal() {
            let newMeal = {
                restaurant: this.restaurant,
                category: this.category['@id'],
                isActive: false,
                minimumQuantity: 1,
                deliveryUnit: 1,
                portionSize: 1,
                servingStyle: 'individual',
                ecoFriendlyPackaging: false,
                hot: null,
                containsAlcohol: null,
            }

            this.$store.dispatch(mealType.actions.SET, newMeal).then(() => {
                this.$router.push({
                    //name: this.$route.name,
                    query: { ...this.$route.query, meal: 'new' },
                })
            })
        },

        itemsUpdated() {
            this.$emit('items-updated')
        },
    },
}
</script>
